import { render, staticRenderFns } from "./SpecimenProtocolPopup.vue?vue&type=template&id=4f3d6ea7&scoped=true&"
import script from "./SpecimenProtocolPopup.vue?vue&type=script&lang=js&"
export * from "./SpecimenProtocolPopup.vue?vue&type=script&lang=js&"
import style0 from "./SpecimenProtocolPopup.vue?vue&type=style&index=0&id=4f3d6ea7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3d6ea7",
  null
  
)

export default component.exports